module.exports = __webpack_public_path__ + "static/media/DQ-Aligment.e48daab2.png";